import React from 'react'
import { useHistory } from 'react-router'
import { toast } from 'react-toastify'
import * as yup from 'yup'
import { useFormik } from 'formik'
import { useStores } from 'presentation/hooks/use-stores'
import { useServices } from 'presentation/hooks/use-services'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import { SurgicalScheduleModel } from 'domain/entities/surgical-schedule-model'
import Modal from 'presentation/shared/components/Modal'
import DividerNew from 'presentation/shared/components/DividerNew'
import TextAreaNew from 'presentation/shared/components/TextAreaNew'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import { ReactComponent as CloseIcon } from 'presentation/assets/icons/close.svg'
import { ReactComponent as AlertFilled } from 'presentation/assets/icons/alert-filled.svg'
import * as S from './styles'

type Props = {
  show: boolean
  close: () => void
  surgicalSchedule: SurgicalScheduleModel
} & WithLoadingProps

const CancelScheduleSurgicalRequestModal = WithLoading(
  ({ show, close, surgicalSchedule, setIsLoading }: Props) => {
    const history = useHistory()
    const user = useStores().currentAccount?.getCurrentAccount()?.user
    const surgicalScheduleService = useServices().surgicalSchedule

    const { values, handleChange, touched, errors, handleSubmit } = useFormik({
      initialValues: {
        canceling_reason: ''
      },
      validationSchema: validationSchema,
      validateOnMount: true,
      onSubmit: async (values) => {
        try {
          close()
          setIsLoading(true)

          await surgicalScheduleService.cancelSurgicalScheduleRequest({
            scheduling_id: surgicalSchedule.scheduling_id,
            reason_to_cancel_solicitation: values.canceling_reason,
            cancel_solicitation_by_name: user.name,
            cancel_solicitation_by_id: user.user_id
          })

          toast.success('A solicitação de agendamento foi cancelada.')
          history.push('/setor-de-marcacao/agendamentos-cancelados')
        } catch (error: any) {
          toast.error(error.message)
        } finally {
          setIsLoading(false)
        }
      }
    })

    return (
      <Modal
        style={{
          display: 'block',
          width: 'auto',
          padding: 20
        }}
        show={show}
        close={close}
        preventAutomateClose
      >
        <S.WrapperModal>
          <S.ModalInfo>
            <S.Title>Cancelar solicitação de agendamento</S.Title>
            <CloseIcon onClick={close} />
          </S.ModalInfo>
          <DividerNew />

          <S.AlertPanel>
            <AlertFilled width={200} />
            <span>
              <strong>Atenção: </strong>
              Ao cancelar, a solicitação será invalidada. Para agendar este
              aviso uma nova solicitação deverá ser feita.
            </span>
          </S.AlertPanel>

          <form onSubmit={handleSubmit}>
            <TextAreaNew
              rows={3}
              dataTestId="pendency-text-area"
              placeholder="Digite aqui"
              label="Informe o motivo de cancelar a solicitação de cancelamento*"
              name="canceling_reason"
              value={values.canceling_reason}
              error={touched.canceling_reason && errors.canceling_reason}
              onChange={handleChange}
            />

            <S.StatusButtonPanel>
              <ButtonNew type="button" variant="text" onClick={close}>
                Manter solicitação
              </ButtonNew>

              <ButtonNew
                type="submit"
                disabled={!values.canceling_reason.trim()}
              >
                Cancelar solicitação
              </ButtonNew>
            </S.StatusButtonPanel>
          </form>
        </S.WrapperModal>
      </Modal>
    )
  }
)

export default CancelScheduleSurgicalRequestModal

const validationSchema = yup.object().shape({
  canceling_reason: yup.string().required('Campo obrigatório')
})
